import { TabsExportState } from './export-types';
import {
  OPEN_TABS_EXPORT,
  CLOSE_TABS_EXPORT,
  LOAD_TABS_REQUEST,
  LOAD_TABS_SUCCESS,
  LOAD_TABS_FAILURE,
  SET_ACTIVE_TAB,
  SET_TOGGLE,
  TOGGLE_ITEM,
  SELECT_ALL_FOR_TAB,
  CLEAR_ALL_FOR_TAB,
  SUBMIT_EXPORT_REQUEST,
  SUBMIT_EXPORT_SUCCESS,
  SUBMIT_EXPORT_FAILURE,
  TabsExportAction,
} from './export-actions';

export const TABS_EXPORT_STATE_KEY = 'TABS_EXPORT_REDUCER';

const initialState: TabsExportState = {
  open: false,
  loading: false,
  error: null,
  data: {},
  selected: {},
  selectAll: {},
  activeTab: undefined,
  toggleValue: 'Existing',
  submitting: false,
  submitError: null,
};

export function tabsExportReducer(state: TabsExportState = initialState, action: TabsExportAction): TabsExportState {
  switch (action.type) {
    case OPEN_TABS_EXPORT:
      console.log('Reducer: OPEN_TABS_EXPORT');
      return { ...state, open: true, error: null };
    case CLOSE_TABS_EXPORT:
      console.log('Reducer: CLOSE_TABS_EXPORT');
      return { ...initialState, open: false };

    case LOAD_TABS_REQUEST:
      return { ...state, loading: true, error: null };
    case LOAD_TABS_SUCCESS: {
      const keys = Object.keys(action.payload || {});
      return {
        ...state,
        loading: false,
        data: action.payload,
        activeTab: keys[0],
      };
    }
    case LOAD_TABS_FAILURE:
      return { ...state, loading: false, error: action.error };

    case SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };
    case SET_TOGGLE:
      return { ...state, toggleValue: action.payload };

    case TOGGLE_ITEM: {
      const { tabKey, item, checked } = action.payload;
      const prevSet = state.selected[tabKey] ? new Set(state.selected[tabKey]) : new Set<string>();
      if (checked) prevSet.add(item);
      else prevSet.delete(item);

      // update selectAll flag for this tab
      const total = state.data[tabKey]?.length || 0;
      const allSelected = total > 0 && prevSet.size === total;

      return {
        ...state,
        selected: { ...state.selected, [tabKey]: prevSet },
        selectAll: { ...state.selectAll, [tabKey]: allSelected },
      };
    }

    case SELECT_ALL_FOR_TAB: {
      const { tabKey, checked } = action.payload;
      const items = state.data[tabKey] || [];
      const newSet = new Set<string>(checked ? items : []);
      return {
        ...state,
        selected: { ...state.selected, [tabKey]: newSet },
        selectAll: { ...state.selectAll, [tabKey]: checked },
      };
    }

    case CLEAR_ALL_FOR_TAB: {
      const tabKey = action.payload;
      const clone = { ...state.selected };
      delete clone[tabKey];
      const selectAll = { ...state.selectAll, [tabKey]: false };
      return { ...state, selected: clone, selectAll };
    }

    case SUBMIT_EXPORT_REQUEST:
      return { ...state, submitting: true, submitError: null };
    case SUBMIT_EXPORT_SUCCESS:
      return { ...state, submitting: false };
    case SUBMIT_EXPORT_FAILURE:
      return { ...state, submitting: false, submitError: action.error };

    default:
      return state;
  }
}
